import { CHECK_IF_EMAIL_ACCOUNT_IS_PASSWORDLESS } from "../../store/utils/routes";
import { makeBackendGetCallWithJsonResponse } from "../../store/utils/fetch";

export const checkIfPasswordlessAccount = async (email: string) => {
  return makeBackendGetCallWithJsonResponse(
    CHECK_IF_EMAIL_ACCOUNT_IS_PASSWORDLESS,
    "?email=" + encodeURIComponent(email.toLowerCase().trim()),
  );
};
